export default "__VITE_ASSET__DO8ZM9LF__"